module.exports = __webpack_public_path__ + "static/img/pro-5.a4f72bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/pro-5.png
// module id = 6AZu
// module chunks = 1